import React from 'react';

export default function Flammable({ width, height }) {
  return (
    <svg
      width={width || '35'}
      height={height || '40'}
      viewBox="0 0 35 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_101_2630)">
        <path
          d="M27.032 22.0066C27.032 27.1112 22.7648 31.2498 17.5 31.2498C12.2352 31.2498 7.96797 27.1112 7.96797 22.0066C7.96797 15.0742 16.7059 9.29725 16.7059 2.75C18.6908 3.71206 21.8689 7.11355 21.8689 11.608C21.8689 13.5337 21.4715 15.4594 21.4715 15.4594C23.8547 14.6891 23.8547 11.9932 23.8547 11.9932C23.8547 11.9932 27.032 16.2296 27.032 22.0066Z"
          fill="#FFCC83"
          stroke="#ED6113"
          strokeLinejoin="round"
        />
        <path
          d="M17.3418 14.6212C17.4258 15.0256 17.4712 15.4439 17.4712 15.8729C17.4712 20.5476 12.4468 20.9074 11.8383 24.647C11.4 27.336 12.8635 30.7976 17.3025 30.7976C20.58 30.7976 23.2359 27.8991 23.2359 24.3243C23.2359 20.7949 18.3332 14.7761 17.3418 14.6212Z"
          fill="#F4893D"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_101_2630"
          x="-3.5"
          y="0"
          width="42"
          height="42"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_101_2630"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_101_2630"
            result="effect2_dropShadow_101_2630"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_101_2630"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
